/**
 * Build-time fallback for preload query batching.
 *
 * Production SPA and SSR builds replace this module via
 * @devtools/parcel-resolver-spa-module-replacements and
 * @devtools/parcel-resolver-ssr-module-replacements with config downloaded
 * from the Bifrost CDN.
 */
export const Q: readonly string[] = [];
export const R: Readonly<Record<string, string>> = {};
export const generatedAt: string | null = null;
/** CDN URL the config was downloaded from — `null` for the checked-in fallback. */
export const sourceUrl: string | null = null;
